const BASE_DOMAIN = location.hostname.match(/chatbot\.(.+)/)?.[1] || 'shopee.sg';

export function cdnFile(hash = '') {
  if (!hash) {
    return '';
  }

  if (hash.startsWith('https://') || hash.startsWith('http://')) {
    return hash;
  }


  return `https://cf.${BASE_DOMAIN.replace(/(test|uat|staging)\./, '')}/file/${hash}`;
}
